import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon  } from '@fortawesome/free-solid-svg-icons';

const ThemeSwitcher = () => {
  // Initialize theme state with value from localStorage if available
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light'; // Default to 'light' theme if none is stored
  });

  // Effect to apply the theme class to the document and save the current theme to localStorage
  useEffect(() => {
    document.documentElement.classList.remove('theme-light', 'theme-dark');
    document.documentElement.classList.add(`theme-${theme}`);
    localStorage.setItem('theme', theme); // Save current theme to localStorage
  }, [theme]); // Re-run the effect when theme changes

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <button onClick={toggleTheme} className="flex items-center">
      <FontAwesomeIcon icon={theme === 'light' ? faMoon : faSun} className="text-lg hover:text-gray-500" />
      {/*<span className="ml-2">{theme === 'light' ? 'Dark' : 'Light'} Mode</span>*/}
    </button>
  );
};

export default ThemeSwitcher;

